import { COLORS, newLayout } from '../theme';

export default {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      '&&&&': {
        margin: 0,
        color: COLORS.kinetikBlack,
        fontSize: newLayout.fontSize.body1,
        textTransform: 'none',
        backgroundColor: COLORS.white,
        borderRadius: newLayout.borderRadius.secondary,
        transition: '0.15s ease',

        '&:hover': {
          borderColor: 'var(--primary-action-color)',
          boxShadow: '0px 4px 8px rgba(8, 15, 29, 0.06)',
        },

        '&:active, &.Mui-selected': {
          color: COLORS.white,
          backgroundColor: 'var(--primary-action-color)',
          borderColor: 'transparent',

          '&.Mui-disabled': {
            color: COLORS.black70,
            backgroundColor: COLORS.black30,
          },
        },

        '&.Mui-disabled': {
          color: COLORS.black40,
          borderColor: COLORS.black10,
          boxShadow: 'none !important',
        },

        '&.MuiToggleButton-sizeSmall': {
          height: 36,
        },

        '&.MuiToggleButton-sizeLarge': {
          height: 68,
          boxShadow: '0px 4px 16px rgba(8, 15, 29, 0.06)',
        },
      },

      // icon

      // .MuiToggleButton-root {
      '&& [class*=MuiChip-sizeIcon]': {
        marginLeft: -6,
        marginRight: newLayout.spacing.s3,
        backgroundColor: COLORS.black04,
        borderColor: COLORS.black40,
        cursor: 'pointer',

        path: {
          fill: COLORS.black40,
        },
      },

      '&.MuiToggleButton-sizeSmall [class*=MuiChip-sizeIcon]': {
        width: newLayout.heights.xs,
        height: newLayout.heights.xs,
        marginRight: newLayout.spacing.s2,

        svg: {
          fontSize: newLayout.fontSize.body2,
        },
      },

      '&.MuiToggleButton-sizeMedium [class*=MuiChip-sizeIcon]': {
        width: newLayout.heights.s,
        height: newLayout.heights.s,

        svg: {
          fontSize: newLayout.fontSize.body1,
        },
      },

      '&:hover [class*=MuiChip-sizeIcon], &:active [class*=MuiChip-sizeIcon], &.Mui-selected [class*=MuiChip-sizeIcon]':
        {
          backgroundColor: 'var(--primary-action-soft)',
          borderColor: 'var(--primary-action-color)',

          path: {
            fill: 'var(--primary-action-color)',
          },
        },

      '&.Mui-selected [class*=MuiChip-sizeIcon]': {
        backgroundColor: COLORS.white,
      },

      '&.Mui-disabled [class*=MuiChip-sizeIcon]': {
        backgroundColor: COLORS.black02,
        borderColor: COLORS.black20,

        path: {
          fill: COLORS.black20,
        },
      },
      '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
        borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
      },

      '&.MuiToggleButtonGroup-grouped:not(:first-of-type):hover': {
        borderLeft: '1px solid var(--primary-action-color)',
      },
    },
  },
};
